import { LogOut, KeyRound, Menu } from 'lucide-react';
import { Button } from '@travellegacy/nexops-design-system';
import { useAuth } from '@/shared/contexts/AuthContext';
import { useState } from 'react';
import { ChangePasswordModal } from '@/features/identity/components/ChangePasswordModal';
import { NotificationBell } from '@/features/notifications/components/NotificationBell';

interface HeaderProps {
  onMenuClick?: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { user, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  return (
    <header className="sticky top-0 z-10 border-b bg-card">
      <div className="flex h-16 items-center justify-between px-4 sm:px-6">
        <div className="flex items-center space-x-2 sm:space-x-3">
          {/* Botão menu hamburger (apenas mobile) */}
          <Button
            variant="ghost"
            size="icon"
            onClick={onMenuClick}
            className="lg:hidden"
            aria-label="Abrir menu"
          >
            <Menu className="h-5 w-5" />
          </Button>
        </div>

        <div className="flex items-center space-x-2 sm:space-x-4">
          <NotificationBell />

          {/* User Menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-2 rounded-lg px-2 sm:px-3 py-2 hover-icon transition-colors"
            >
              <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center text-primary-foreground text-sm font-bold">
                {user?.name.charAt(0).toUpperCase()}
              </div>
              <div className="text-left hidden sm:block">
                <p className="text-sm font-medium text-card-foreground">{user?.name}</p>
                <p className="text-xs text-muted-foreground">{user?.role}</p>
              </div>
            </button>

            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-64 bg-card rounded-lg shadow-lg border py-1">
                <div className="px-4 py-2 border-b">
                  <p className="text-sm font-medium text-card-foreground truncate">{user?.name}</p>
                  <p className="text-xs text-muted-foreground truncate" title={user?.email}>
                    {user?.email}
                  </p>
                </div>
                <button
                  onClick={() => {
                    setShowUserMenu(false);
                    setShowChangePasswordModal(true);
                  }}
                  className="w-full text-left px-4 py-2 text-sm text-card-foreground hover-menu flex items-center"
                >
                  <KeyRound className="h-4 w-4 mr-2" />
                  Alterar Senha
                </button>
                <button
                  onClick={() => {
                    setShowUserMenu(false);
                    logout();
                  }}
                  className="w-full text-left px-4 py-2 text-sm text-destructive hover:bg-destructive/10 flex items-center"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Sair
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <ChangePasswordModal
        isOpen={showChangePasswordModal}
        onClose={() => setShowChangePasswordModal(false)}
      />
    </header>
  );
}
